import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { PhotoAdder } from "./Photos";
import { VoiceRecorder } from "./VoiceButton";
import { ClassDoneList, HomeworkList } from "./HomeLists";

export const StudentHome = ({ day, onSaved }) => {
  const [undone, setUndone] = useState([]);
  const [hwDone, setHwDone] = useState([]);
  const [note, setNote] = useState("");
  const [help, setHelp] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setUndone(day.home.class_undone || []); setHwDone(day.home.hw_done || []); setNote(day.home.note || ""); setHelp(day.home.help || ""); }, [day.date]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/student/diary/home", { date: day.date, class_undone: undone, hw_done: hwDone, note, help });
      toast.success(data.streak > 1 ? `Saved · ${data.streak} days in a row!` : "Saved");
      onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4 rounded-2xl border border-slate-200 bg-white p-4" data-testid="student-home">
      <ClassDoneList items={day.class_items} undone={undone} setUndone={setUndone} />
      <p className="text-base font-extrabold text-slate-900">What did you do today?</p>
      <HomeworkList items={day.hw_items} done={hwDone} setDone={setHwDone} />
      <div>
        <p className="mb-1 text-sm font-bold text-slate-800">Extra work I did (type or speak Hindi/English)</p>
        <div className="flex items-start gap-2">
          <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={500} className="flex-1 rounded-lg border border-slate-300 p-2 text-sm" data-testid="home-note" />
          <VoiceRecorder url="/student/diary/voice" onText={(t) => setNote((x) => (x ? `${x} ${t}` : t))} testid="home-voice" />
        </div>
      </div>
      <div>
        <p className="mb-1 text-sm font-bold text-slate-800">I need help with… (goes to your teacher)</p>
        <input value={help} onChange={(e) => setHelp(e.target.value)} maxLength={300} className="h-10 w-full rounded-lg border border-slate-300 px-2 text-sm" data-testid="home-help" />
      </div>
      <div>
        <p className="mb-1 text-sm font-bold text-slate-800">Photo of notebook / book page</p>
        <PhotoAdder date={day.date} photos={day.photos} onChanged={onSaved} />
      </div>
      <Button onClick={save} disabled={busy} className="bg-emerald-700 hover:bg-emerald-800" data-testid="home-save">{busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Save my day</Button>
    </div>
  );
};
